module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAbCAYAAACJISRoAAABXElEQVRIic2WPy+EQRDGf+TO36C+SqJxhVJQ0Ko1EolGwgfQaRQKBZXGV9CoFBIkSl9AKSIRjVCdILnLSUYm2ZPXiLF7t8STbLKZfd59dnbnnZkuEcFBH9DvEX7AG/CMinwzlkSkIZ1j3/PkDJjvwIsWmt3O4kAGAUW5BKwBm8CwWRzKJIJe1wswGMFtAkcRvFmg8smS8Kw1J0iK49h+WDKnWAYew3wPmIi+EwdW5AK4C/OaWdMgGYvY80vAWBEPGgg3OTzxUAe2IngrQLVdkQawG8GbsyLez5gNKZ6UgcUIXsUaUkQ0ag7b8S5F5BVYiOBtA9PtimhtOI/grVvDv3t4rZI7EbyqNaSI9AIbCfwP/Ml1qYjbSeQSuf9ljQd9kxNgNRgOQiIkVy0BTrX8jgKXwEimTYt4AiZbZXNKRK4z9FhF3IrIjO5f7Lt6Qp81nhjaFpoZrkJ2qAO8A8uOSpFYHMA9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/baiicon/icon_wz.png
// module id = bJd5
// module chunks = 10